<template>
    <div class="@container relative aspect-[146/210]">
        <svg
            class="absolute inset-0 h-full w-full"
            viewBox="124 101 146 210"
            fill="none"
            aria-hidden="true"
        >
            <path
                d="M262.283 147.653V266.75H130.462V147.653C130.462 145.196 131.804 143.198 133.455 143.198H259.291C260.941 143.198 262.283 145.196 262.283 147.653Z"
                fill="black"
            />
            <path
                d="M262.283 155.912V235.028L257.936 241.811L257.86 256.716L250.613 264.74L248.799 266.75H145.778L143.588 264.74L135.684 257.48L135.331 239.601L130.483 231.697L130.462 231.663V156.471L132.462 156.331V231.627L132.368 231.632L137.439 239.371L137.634 256.571L147.045 264.74H247.443L255.911 255.809L255.825 241.58L260.283 235.064V155.912H262.283Z"
                fill="#011119"
            />
            <path
                d="M256.875 118.261H136.227C129.302 118.445 123.889 123.119 124.054 130.433V148.47L140.604 131.674H251.908L269.049 148.47V130.433C269.049 123.722 263.588 118.261 256.877 118.261H256.875Z"
                fill="#1E1E1E"
            />
            <path
                d="M255.522 126.542H138.916L124.051 142.347V294.73L138.916 310.538H255.522L269.046 296.031V141.049L255.522 126.542ZM262.284 258.978L250.694 271.096L142.901 270.836L130.464 258.714V156.31L142.901 144.186L250.694 143.927L262.284 156.045V258.978Z"
                :fill="palette.accent"
            />
            <path
                opacity="0.2"
                d="M186.978 118.261H256.878C256.878 118.261 269.051 118.404 269.051 131.417V139.022L268.42 138.39L268.456 131.442C268.456 131.442 269.487 120.581 256.875 118.918L187.543 119.062L186.978 118.261Z"
                fill="white"
            />
            <path
                d="M269.05 141.012L255.571 126.544H181.12L180.369 125.454H256.164L269.05 139.114V141.012Z"
                fill="#1D252D"
            />
            <path
                d="M200.636 134.871L199.931 136.746L200.709 136.848L199.748 135.233C200.041 134.939 200.636 134.871 200.636 134.871Z"
                fill="#1D252D"
            />
            <path
                d="M124.051 143.196L139.081 127.049L187.393 127.051L199.925 137.492V136.746L187.599 126.545H138.829L124.051 142.347V143.196Z"
                :fill="palette.accent"
            />
            <path
                d="M199.929 137.493H202.938L202.545 136.848L199.929 136.746V137.493Z"
                :fill="palette.accent"
            />
            <path
                d="M262.283 155.808V224.368L257.933 217.324L257.862 158.449L248.785 148.47L145.813 148.38L135.645 157.693L135.252 219.584L130.462 227.475V155.972L142.678 143.926H250.695L262.283 155.808Z"
                fill="#1E1E1E"
            />
            <path
                d="M262.283 259.354V234.767L257.933 241.81L257.862 256.713L248.785 266.691L145.813 266.781L135.645 257.469L135.252 239.553L130.462 231.66V259.19L142.678 271.235H250.695L262.283 259.354Z"
                :fill="palette.accent"
            />
            <path
                d="M146.895 101L138.837 126.544L162.649 126.547L174.975 137.494L241.794 136.847L220.068 101H146.895Z"
                fill="#1E1E1E"
            />
            <path
                opacity="0.2"
                d="M220.755 102.242L147.516 101.911L141.999 119.221L135.514 119.244C126.002 119.651 125.005 129.348 125.005 129.348L124.915 141.678L124.051 142.488L124.101 129.348C124.424 119.514 134.812 118.262 134.812 118.262H141.453L146.831 101H220.001L220.755 102.243V102.242Z"
                fill="white"
            />
            <path
                opacity="0.2"
                d="M220.002 101H218.62L239.957 136.85H241.794L220.002 101Z"
                fill="white"
            />
        </svg>
        <KillerAvatar
            :avatar="avatar"
            :color="color"
            class="absolute top-[27.14%] left-[17.84%] w-[63.7%]"
        />
        <span
            ref="label"
            class="font-title absolute top-[90.5%] left-1/2 -translate-x-1/2 -translate-y-1/2 leading-none font-bold whitespace-nowrap text-white uppercase"
            :style="{ fontSize: `${labelSize}cqw` }"
        >
            {{ label }}
        </span>
    </div>
</template>

<script>
import { getKillerPalette } from '../killerPalette.js'
import KillerAvatar from './KillerAvatar.vue'

const LABEL_WIDTH_RATIO = 0.75
const MAX_LABEL_SIZE = 13.5

export default {
    name: 'KillerBadge',
    components: { KillerAvatar },
    props: {
        avatar: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            labelSize: MAX_LABEL_SIZE,
        }
    },
    computed: {
        palette() {
            return getKillerPalette(this.color)
        },
    },
    async mounted() {
        await document.fonts?.ready
        this.fitLabel()
    },
    methods: {
        fitLabel() {
            const labelWidth = this.$refs.label?.offsetWidth
            const availableWidth = this.$el.offsetWidth * LABEL_WIDTH_RATIO
            if (!labelWidth || !availableWidth) return

            this.labelSize = Math.min(
                MAX_LABEL_SIZE,
                (this.labelSize * availableWidth) / labelWidth,
            )
        },
    },
}
</script>
